import { Spinner } from '@frontend/components/common';
import { CommonMessage } from '@frontend/lang';

import WizardScreenContainer from '../../components/wizard-screen-container/wizard-screen-container.component';
import { useCreateRecycleTransaction } from './create-recycle-transaction.controller';

export const CreateRecycleTransaction = () => {
    const viewProps = useCreateRecycleTransaction();

    return (
        <WizardScreenContainer
            id='create-recycle-transaction'
            errorModal={{
                show: !!viewProps.error,
                title: CommonMessage.WIZARD.RECYCLE.CREATE_TRANSACTION.TITLE,
                message: viewProps.error,
                onClose: viewProps.resetError
            }}>
            <div className='flex size-full items-center justify-center'>
                <Spinner className='text-border-default fill-brand-primary size-12' />
            </div>
        </WizardScreenContainer>
    );
};
